<template src="./Agent.html" />

<script>
import moment from "moment"
import mixins from "@/Mixins.js"
import { useStore } from "@/store/store.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"
export default {
  name: "agent",
  props: ["agentId"],
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      emailRegistered: null,
      openCollapse: true,
      partners: [],
      modalFuncionalities: false,
      funcionalities: [],
      funcionalitiesUser: [],
      funcionalitiesUserSelected: [],
      partnerId: null,
      clientName: null,
      name: null,
      documentType: "cpf",
      document: null,
      gender: null,
      birthdate: null,
      email: null,
      zipcode: "",
      city: "",
      complement: "",
      neighborhood: "",
      number: "",
      state: "",
      street: "",
      aasUserId: null,
      userId: null,
      addressId: null,
      zipcodeStartZone: null,
      zipcodeEndZone: null,
      validZipStartZone: true,
      validZipEndZone: true,
      validZipcode: true,
      invalidFields: {
        name: false,
        gender: false,
        cpf: false,
        cnpj: false,
        birthdate: false,
        email: false,
        zipcode: false,
        city: false,
        number: false,
        state: false,
        street: false,
        zipcodeStartZone: false,
        zipcodeEndZone: false,
        clientName: false,
        partnerId: false
      },
      genderOptions: [
        { text: "Feminino", value: "F" },
        { text: "Masculino", value: "M" },
      ],
      documentsOptions: [
        { text: "CPF", value: "cpf" },
        { text: "CNPJ", value: "cnpj" },
      ],
      showButtonGoback: false,
      disable: {
        street: false,
        city: false,
        state: false
      },
      saveClicked:false,
    };
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  mounted() {
    const vm = this;
    vm.init();
    this.getFuncionalities();
    this.getPartners();
  },
  computed: {
    existFunc() {
      return !(this.funcionalities.length > 0)
    },
  },
  watch: {
    name: function (newVal) {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    gender: function (newVal) {
      const vm = this;
      vm.invalidFields.gender = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    document: function (newVal) {
      const vm = this;
      if (vm.documentType === "cpf") {
        (vm.invalidFields.cpf = vm.testNullUndefinedEmpty(newVal) || !vm.validateCPF(newVal)) && vm.saveClicked;
      }
      if (vm.documentType === "cnpj") {
        (vm.invalidFields.cnpj = vm.testNullUndefinedEmpty(newVal) || !vm.validateCNPJ(newVal)) && vm.saveClicked;
      } 
    },
    birthdate: function (newVal) {
      const vm = this;
      vm.invalidFields.birthdate = !vm.validateBirthDate(newVal) && vm.saveClicked;
    },
    email: function (newVal) {
      const vm = this;
      vm.invalidFields.email = !vm.validateEmail(newVal) && vm.saveClicked;
    },
    partnerId : function(newVal) {
      this.invalidFields.partnerId = (this.testNullUndefinedEmpty(newVal)) && this.saveClicked;
    },
    clientName : function(newVal) {
      this.invalidFields.clientName = (this.testNullUndefinedEmpty(newVal)) && this.saveClicked;
    },
    state: function (newVal) {
      const vm = this;
      vm.invalidFields.state = ( vm.testNullUndefinedEmpty(newVal)) && vm.saveClicked;
    },
    city: function (newVal) {
      const vm = this;
      vm.invalidFields.city = (vm.invalidFields.city = vm.testNullUndefinedEmpty(newVal)) && vm.saveClicked;
    },
    number: function (newVal) {
      const vm = this;
      vm.invalidFields.number = (vm.testNullUndefinedEmpty(newVal)) && vm.saveClicked;
    },
    street: function (newVal) {
      const vm = this;
      vm.invalidFields.street = (vm.testNullUndefinedEmpty(newVal)) && vm.saveClicked;
    },
    zipcode: function (newVal) {
      const vm = this;
      vm.invalidFields.zipcode = (vm.testNullUndefinedEmpty(newVal) || !vm.validZipcode) && vm.saveClicked;
    },
    zipcodeStartZone: function (newVal) {
      const vm = this;
      vm.invalidFields.zipcodeStartZone = (vm.testNullUndefinedEmpty(newVal) ||!vm.validZipStartZone) && vm.saveClicked;
    },
    zipcodeEndZone: function (newVal) {
      const vm = this;
      vm.invalidFields.zipcodeEndZone = (vm.testNullUndefinedEmpty(newVal) || !vm.validZipEndZone) && vm.saveClicked;
    }
  },
  methods: {
    init() {
      const vm = this;
      if (vm.$props.agentId !== undefined) {
        vm.getAgentData();
      }
      if (vm.$route.name === "aas-registered-agents") {
        vm.showButtonGoback = true;
      }
    },
    getAgentData() {
      const vm = this;
      let agent = {
        id: vm.$props.agentId,
      };
      vm.axios
        .get(
          vm.$store.state.filooServer + "aas/users/" + vm.$props.agentId,
          agent,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.getPermissionsUser(response.data.user.id);
            vm.fillFieldsAgentData(response.data);
          }
        });
    },
    fillFieldsAgentData(aas) {
      const vm = this;
      vm.name = vm.testNullUndefinedEmpty(aas.user.name) ? null : aas.user.name;
      vm.partnerId = vm.testNullUndefinedEmpty(aas.partnerId) ? null : aas.partnerId;
      this.clientName = this.partners.find(pack => {return pack.name === aas.clientName});
      vm.gender = vm.testNullUndefinedEmpty(aas.user.gender)
        ? null
        : vm.genderOptions.find(g => {return g.value === aas.user.gender });
      vm.email = vm.testNullUndefinedEmpty(aas.user.email)
        ? null
        : aas.user.email;
      vm.birthdate = vm.testNullUndefinedEmpty(aas.birthdate)
        ? null
        : vm.formatDateBrToTypeDate(aas.birthdate);
      vm.zipcodeStartZone = vm.testNullUndefinedEmpty(aas.occupationArea1)
        ? null
        : aas.occupationArea1;
      vm.zipcodeEndZone = vm.testNullUndefinedEmpty(aas.occupationArea2)
        ? null
        : aas.occupationArea2;
      vm.document = vm.testNullUndefinedEmpty(aas.cpfCnpj) ? null : aas.cpfCnpj;
      if (
        vm.testNullUndefinedEmpty(aas.cpfCnpj) === false &&
        aas.cpfCnpj.length <= 14
      ) {
        vm.documentType = "cpf";
      } else if (
        vm.testNullUndefinedEmpty(aas.cpfCnpj) === false &&
        aas.cpfCnpj.length > 14
      ) {
        vm.documentType = "cnpj";
      }
      vm.zipcode = vm.testNullUndefinedEmpty(aas.address.zipcode)
        ? null
        : aas.address.zipcode;
      vm.street = vm.testNullUndefinedEmpty(aas.address.street)
        ? null
        : aas.address.street;
      vm.number = vm.testNullUndefinedEmpty(aas.address.number)
        ? null
        : aas.address.number;
      vm.complement = vm.testNullUndefinedEmpty(aas.address.complement)
        ? null
        : aas.address.complement;
      vm.state = vm.testNullUndefinedEmpty(aas.address.state)
        ? null
        : aas.address.state;
      vm.city = vm.testNullUndefinedEmpty(aas.address.city)
        ? null
        : aas.address.city;
      vm.neighborhood = vm.testNullUndefinedEmpty(aas.address.neighborhood)
        ? null
        : aas.address.neighborhood;
      vm.aasUserId = aas.id;
      vm.userId = aas.user.id;
      vm.addressId = aas.address.id;
    },
    async getAddress() {
      const response = await this.getAddressByZipcode(this.zipcode)

      this.validZipcode = response && response.address
      this.state = ""
      this.street = ""
      this.city = ""

      if (this.validZipcode) {
        this.zipcode = response.address.zipcode
        this.city = response.address.city
        this.neighborhood = response.address.neighborhood
        this.state = response.address.state
        this.street = response.address.street
      }

      this.disable.street = !this.street
      this.disable.city = !this.city
      this.disable.state = !this.state
    },
    checkFalseInvalidFields() {
      const vm = this;
      vm.invalidFields.name = false;
      vm.invalidFields.gender = false;
      vm.invalidFields.cpf = false;
      vm.invalidFields.cnpj = false;
      vm.invalidFields.birthdate = false;
      vm.invalidFields.email = false;
      vm.invalidFields.partnerId = false;
      vm.invalidFields.zipcode = false;
      vm.invalidFields.city = false;
      vm.invalidFields.number = false;
      vm.invalidFields.state = false;
      vm.invalidFields.street = false;
      vm.invalidFields.zipcodeStartZone = false;
      vm.invalidFields.zipcodeEndZone = false;
      this.invalidFields.partnerId = false;
      this.invalidFields.clientName = false;
      vm.saveClicked = true;
    },
    clearAllFields() {
      const vm = this;
      vm.name = null;
      vm.gender = null;
      vm.birthdate = null;
      vm.document = null;
      vm.email = null;
      vm.partnerId = null;
      this.clientName = null;
      vm.zipcode = null;
      vm.city = null;
      vm.number = null;
      vm.state = null;
      vm.street = null;
      vm.zipcodeStartZone = null;
      vm.zipcodeEndZone = null;
    },
    validateFields() {
      const vm = this;
      let invalid = false;

      vm.checkFalseInvalidFields();
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.name);
      vm.invalidFields.gender = vm.testNullUndefinedEmpty(vm.gender);
      vm.invalidFields.birthdate = !vm.validateBirthDate(vm.birthdate);
      vm.invalidFields.email = !vm.validateEmail(vm.email);
      vm.invalidFields.partnerId = vm.testNullUndefinedEmpty(vm.partnerId);
      vm.invalidFields.zipcode = vm.testNullUndefinedEmpty(vm.zipcode) || !vm.validZipcode;
      vm.invalidFields.street = vm.testNullUndefinedEmpty(vm.street);
      vm.invalidFields.number =  vm.testNullUndefinedEmpty(vm.number);
      vm.invalidFields.city = vm.testNullUndefinedEmpty(vm.city);
      vm.invalidFields.state = vm.testNullUndefinedEmpty(vm.state);
      this.invalidFields.zipcodeStartZone = this.testNullUndefinedEmpty(this.zipcodeStartZone) ||!this.validZipStartZone;
      this.invalidFields.zipcodeEndZone = this.testNullUndefinedEmpty(this.zipcodeEndZone) || !this.validZipEndZone;
      this.invalidFields.clientName = this.testNullUndefinedEmpty(this.clientName);

      if (vm.documentType === "cpf") {
        vm.invalidFields.cpf = vm.testNullUndefinedEmpty(vm.document) || !vm.validateCPF(vm.document);
      }
      if (vm.documentType === "cnpj") {
        vm.invalidFields.cnpj = vm.testNullUndefinedEmpty(vm.document) || !vm.validateCNPJ(vm.document);
      } 

      invalid = vm.invalidFields.name || vm.invalidFields.gender || vm.invalidFields.birthdate || vm.invalidFields.email
        || vm.invalidFields.zipcode || vm.invalidFields.street || vm.invalidFields.number || vm.invalidFields.city
        || vm.invalidFields.state || vm.invalidFields.zipcodeStartZone || vm.invalidFields.zipcodeEndZone || vm.invalidFields.partnerId;

      invalid = vm.documentType === "cpf" ? invalid || vm.invalidFields.cpf : invalid || vm.invalidFields.cnpj;
      invalid = this.emailRegistered;
      if (invalid) {
        vm.$vs.notify({
          title: "Atenção!",
          text: "Campos obrigatórios não preenchidos ou inválidos.",
          color: "warning",
          icon: "error",
          position: "top-right",
          time: 4000,
        });
      } else {
        if (vm.testNullUndefinedEmpty(vm.aasUserId)) {
          vm.postAAS();
        } else {
          vm.putAAS();
        }
      }
    },
    postAAS() {
      const vm = this;
      let dateSplit = vm.birthdate.split("-");
      let birthdateFormatted = new Date(
        dateSplit[0],
        dateSplit[1] - 1,
        dateSplit[2]
      );
      let dateMomment = moment(birthdateFormatted).format("YYYY-MM-DD");
      let userAAS = {
        address: {
          zipcode: vm.zipcode,
          street: vm.street,
          number: vm.number,
          neighborhood: vm.neighborhood,
          city: vm.city,
          state: vm.state,
          Latitude: "",
          Longitude: "",
        },
        user: {
          name: vm.name,
          email: vm.email,
          type: "AAS",
          gender: vm.gender.value,
        },
        partnerId: vm.partnerId,
        clientName: this.clientName.name,
        occupationArea1: vm.zipcodeStartZone,
        occupationArea2: vm.zipcodeEndZone,
        birthdate: dateMomment,
        phone: "",
        cpfCnpj: vm.document,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "aas/user/create", userAAS, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(response => {
          if (response.status === 200) {
            vm.saveClicked = false
            this.saveNewPermissions(response.data.user.id);
            vm.$swal(
              "Operação realizada",
              "O AAS <b style='color: #FF9F43; font-weight: 500'>" +
                vm.name +
                "</b> foi criado com sucesso!",
              "success"
            ).then(() => {
              this.$router.push('/aas-registered-agents');
            });
          }
        })
        .catch(function (error) {
          vm.saveClicked = false
          if(error.data.message.includes("CPF")) {
            vm.$swal(
              "Atenção!",
              "CPF ou CNPJ já utilizado, verifique se o agente já possui cadastro ou digite um novo valor.",
              "error"
            ); 
          } else {
            vm.$swal(
              "Atenção!",
              "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema.",
              "error"
            );
          }
        });
    },
    verifyEmailExistant() {
      const user = {
        email: this.email,
        type: "AAS",
      };
      this.emailRegistered = false;
      this.axios
        .post(
          this.$store.state.filooServer + "users/verify-email",
          user,
          {
            headers: { Authorization: this.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.data.id !== this.userId) {
            this.emailRegistered = true;
            this.showNotifyWarning(
              "Email já cadastrado para outro agente.",
              3200
            );
          }
        })
        .catch(() => {
        });
    },

    getPartners() {
      const vm = this;
      this.axios
        .get(`${this.$store.state.filooServer}partner/get-partners`,{
            headers: { Authorization: vm.$session.get("bearerDefault") },
          })
        .then(response => {
          if (response.status === 200) {
            this.partners = response.data;
          }
        });
    },
    putAAS() {
      const vm = this;
      let dateSplit = vm.birthdate.split("-");
      let birthdateFormatted = new Date(
        dateSplit[0],
        dateSplit[1] - 1,
        dateSplit[2]
      );
      let dateMomment = moment(birthdateFormatted).format("YYYY-MM-DD");
      let userAAS = {
        id: vm.aasUserId,
        address: {
          id: vm.addressId,
          zipcode: vm.zipcode,
          street: vm.street,
          number: vm.number,
          neighborhood: vm.neighborhood,
          city: vm.city,
          state: vm.state,
          Latitude: "",
          Longitude: "",
        },
        user: {
          id: vm.userId,
          name: vm.name,
          email: vm.email,
          type: "AAS",
          gender: vm.gender.value,
        },
        partnerId: vm.partnerId,
        clientName: this.clientName.name,
        occupationArea1: vm.zipcodeStartZone,
        occupationArea2: vm.zipcodeEndZone,
        birthdate: dateMomment,
        phone: "",
        cpfCnpj: vm.document,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "aas/user/update", userAAS, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.saveClicked = false
            vm.$swal(
              "Operação realizada",
              "O AAS <b style='color: #FF9F43; font-weight: 500'>" +
                vm.name +
                "</b> foi alterado com sucesso!",
              "success"
            ).then(function(){
              vm.goBackToAASList();
            });
          }
        })
        .catch(function (error) {
          vm.saveClicked = false
          if(error.data.message.includes("CPF")) {
            vm.$swal(
              "Atenção!",
              "CPF ou CNPJ já utilizado, verifique se o agente já possui cadastro ou digite um novo valor.",
              "error"
            ); 
          } else {
            vm.$swal(
              "Atenção!",
              "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema.",
              "error"
            );
          }
        });
    },
    goBackToAASList() {
      this.$emit("showTable")
    },
    resendPassword() {
      const vm = this;
      vm.axios
        .post(
          vm.$store.state.filooServer +
            "aas/resend-email/" +
            vm.$props.agentId,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.$swal({
              title: "Sucesso!",
              text:
                "Operação realizada com sucesso, verifique sua caixa de entrada e de spam.",
              icon: "success"
            });
          }
        })
        .catch(function(error) {
          if(error.data.message.toString().includes("Acesso")) {
            vm.$swal({
              title: "Acesso Negado!",
              text:
                "Não foi possível executar esta operação. Entre em contato com o administrador do sistema ",
              icon: "error"
            });
          } else {
            if(error.data.message.toString().includes("email")) {
              vm.$swal({
                title: "Atenção!",
                text:
                  "Não foi possível executar esta operação. Não há um e-mail cadastrado para o reenvio",
                icon: "error"
              });
            } else {
              vm.$swal({
                title: "Atenção!",
                text:
                  "Não foi possível executar esta operação. Verifique se o e-mail cadastrado é válido e se" +
                  " a caixa de entrada ou de spam estão lotadas. Caso o problema persista entre em contato" +
                  " com o administrador do sistema ",
                icon: "error"
              });
            }
          }
        });
    },
    savePermissions() {
      this.modalFuncionalities = false;
      if (this.$props.agentId !== undefined) {
          this.$vs.loading({
          container: this.$refs.content,
          scale: 0.5
        })
        let params = {
          functionalities: []
        }
        this.funcionalitiesUser.forEach( element => {
          params.functionalities.push({
            id: element,
            start: this.dateInitial,
            end: this.dateFinal,
            source: "AAS"
          })
        })
        this.axios
          .put(
            this.$store.state.filooServer +
              `access/users/${this.userId}/systems/funcionalities`,
            params,
            {
              headers: { Authorization: this.$session.get("bearer") }
            }
          )
          .then( response => {
            if (response.status === 200) {
              this.$vs.loading.close(this.$refs.content);
              this.getPermissionsUser(this.userId);
              this.$swal(
                "Operação realizada",
                "As permissões do agente foram atualizadas com sucesso!",
                "success"
              )
            }
          })
          .catch( () => {
            this.$vs.loading.close(this.$refs.content)
          })
      }else{
        this.$swal(
              "Permissões salvas",
              "As permissões do agente foram salvas com sucesso!",
              "success");
      }       
    },
    getPermissionsUser(userId){
      this.axios
        .get(
          this.$store.state.filooServer +
            `access/users/${userId}/functionalities-user`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          this.funcionalitiesUserSelected = response.data.map((item) => item.id);
          this.syncPermissions();
        })
        .catch( () => {
        })
    },
    syncPermissions() {
      if (this.funcionalities.length > 0 && this.funcionalitiesUserSelected.length > 0) {
        this.funcionalitiesUser = this.funcionalitiesUserSelected;
      }
    },
    getFuncionalities(){
      this.axios
        .get(
          this.$store.state.filooServer +
            `access/users/source/AAS`,
          {
            headers: { Authorization: this.$session.get("bearer") }
          }
        )
        .then( response => {
          this.funcionalities = response.data;
        })
        .catch( () => {
        })
    },
    saveNewPermissions(userId){
      this.modalFuncionalities = false;
      if (userId !== undefined) {
        let params = {
          functionalities: []
        }
        this.funcionalitiesUser.forEach( element => {
          params.functionalities.push({
            id: element,
            start: this.dateInitial,
            end: this.dateFinal,
            source: "AAS"
          })
        })
        this.axios
          .put(
            this.$store.state.filooServer +
              `access/users/${userId}/systems/funcionalities`,
            params,
            {
              headers: { Authorization: this.$session.get("bearer") }
            }
          )
      }    
    },
  },
};
</script>

<style lang="scss" src="./Agent.scss" />